import dtos from '@/dtos/course';

import { FETCH_SHARE, FETCH_COURSE, FETCH_TIMES, BIND_SHARE, REQUEST_SHARE_BINDING } from './types';


export default {
    [FETCH_SHARE](state, payload) {
        state.share = payload;
    },
    [FETCH_COURSE](state, payload) {
        state.course = dtos.course(payload);
    },
    [FETCH_TIMES](state, payload) {
        state.times = payload;
    },
    [BIND_SHARE]() {
    },
    [REQUEST_SHARE_BINDING]() {
    },
};



// WEBPACK FOOTER //
// ./src/store/share/mutations.js